module.exports = __webpack_public_path__ + "img/20180815_150119_060.0ed00161.jpg";